module.exports = __webpack_public_path__ + "static/img/lhb.cbb53a66.png";